import React from "react";
import Context from "../../context";
import { BettedUserType, UserType } from "../../utils/interfaces";

interface AllDataProps {
    pre: boolean;
    setPre: React.Dispatch<React.SetStateAction<boolean>>;
    allData: UserType[] | BettedUserType[];
}

const maskName = (name: string) => {
    if (!name) return "***";
    if (name.length <= 4) return name[0] + "***";
    return name.slice(0, 2) + "***" + name.slice(-2);
};

const AllData = ({ pre, setPre, allData }: AllDataProps) => {
    const { userInfo, bettedUsers } = React.useContext(Context);

    return (
        <>
            <div>
                <div className="all-bets-block">
                    <div>
                        <div className="uppercase">ALL BETS</div>
                        <div>{bettedUsers?.length}</div>
                    </div>
                    <div
                        className={`previous-hand items-center flex justify-between ${pre ? "click" : ""}`}
                        onClick={() => setPre(!pre)}
                    >
                        <div className="history-i"></div>
                        <span className="ml-1">Previous hand</span>
                    </div>
                </div>
                <div className="spacer"></div>
                <div className="legend">
                    <span className="user">User</span>
                    <span className="bet">Bet, {userInfo?.currency || "KSh"}</span>
                    <span>X</span>
                    <span className="cash-out">Cash out, {userInfo?.currency || "KSh"}</span>
                </div>
            </div>
            <div className="cdk-virtual-scroll-viewport scroll-y">
                <div className="cdk-virtual-scroll-content-wrapper">
                    {allData?.map((user: any, key: number) => {
                        const displayUser = user.name || user.userName || "Player";
                        const isMe = displayUser === userInfo?.userName;
                        const betAmt = Number(user.betAmount || 0);
                        const cashOutAmt = Number(user.cashOut || user.cashAmount || 0);
                        const targetMult = Number(user.target || user.multiplier || 0);
                        const cashedOut = user.cashouted;

                        return (
                            <div
                                className={`bet-item ${cashedOut ? "celebrated" : ""} ${isMe ? "border-green" : ""}`}
                                key={key}
                            >
                                <div className="user">
                                    <img
                                        className="avatar"
                                        src={user.img || "./avatars/av-5.png"}
                                        alt="avatar"
                                        onError={(e: any) => { e.target.src = "./avatars/av-5.png"; }}
                                    />
                                    <div className="username">
                                        {displayUser}
                                    </div>
                                </div>
                                <div className="bet">{betAmt.toFixed(2)}</div>
                                {cashedOut && targetMult > 0 && (
                                    <div className="multiplier-block">
                                        <div className={`bubble font-weight-bold ${
                                            targetMult < 2 ? "blue" :
                                            targetMult < 10 ? "purple" : "big"
                                        }`}>
                                            {targetMult.toFixed(2)}x
                                        </div>
                                    </div>
                                )}
                                <div className="cash-out">
                                    {cashOutAmt > 0 ? cashOutAmt.toFixed(2) : ""}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default AllData;
